var render = function render(){
  var _vm$item, _vm$item2, _vm$item3, _vm$item4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "contents",
    attrs: {
      "data-editor-active": ""
    }
  }, [_c('h3', {
    ref: "title",
    staticClass: "title",
    attrs: {
      "data-grid-layout": "title"
    }
  }, [_vm._v(" 공정도 ")]), _c('div', {
    attrs: {
      "data-grid-layout": "tl"
    }
  }), _c('div', {
    attrs: {
      "data-grid-layout": "tr"
    }
  }), _c('div', {
    ref: "process",
    attrs: {
      "data-grid-layout": "content"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$item = _vm.item) !== null && _vm$item !== void 0 && _vm$item.thumbnail),
      expression: "!item?.thumbnail"
    }],
    staticClass: "emptyProcess"
  }, [_vm._v("공정도 이미지가 없습니다.")]), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.thumbnail,
      expression: "item?.thumbnail"
    }],
    staticClass: "processImage",
    attrs: {
      "src": ((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.thumbnail) != null ? `data:image/jpeg;base64,${(_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.thumbnail}` : ''
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }